var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cn from 'classnames';
import { createElement } from 'react';
import { extractSupportProps } from '@snack-uikit/utils';
import { attachVariants } from '../utils';
import { TAG } from './constants';
import { generatedVariants } from './generatedVariants';
import styles from './styles.module.css';
function TypographyComponent(_a) {
    var { tag = TAG.span, className, children, family, purpose, size } = _a, rest = __rest(_a, ["tag", "className", "children", "family", "purpose", "size"]);
    return createElement(tag, Object.assign(Object.assign({ className: cn(styles.typography, className) }, extractSupportProps(rest)), { 'data-family': family, 'data-purpose': purpose, 'data-size': size }), children);
}
export const Typography = attachVariants(TypographyComponent, generatedVariants);
